<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">person</i>
                        </div>
                        <h4 class="card-title ">Edição de dados do usuário</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-6">
                                    

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group bmd-form-group"
                                                v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                                <label for="name" class="bmd-label-floating">Nome *</label>
                                                <input refs="name" type="text" class="form-control" v-model="auth.name" disabled />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group bmd-form-group"
                                                v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
                                                <label for="email" class="bmd-label-floating">E-mail *</label>
                                                <input refs="email" type="text" class="form-control" v-model="auth.email" disabled />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group bmd-form-group"
                                                v-bind:class="{'is-filled': form.email != '', 'has-danger' : validation.email != '' }">
                                                <label for="email" class="bmd-label-floating">Login *</label>
                                                <input refs="email" type="text" class="form-control" v-model="auth.username" disabled />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group bmd-form-group"
                                                v-bind:class="{'is-filled': form.password != '', 'has-danger' : validation.password != '' }">
                                                <input refs="password" :type="dataType.password" class="form-control" v-model="form.password" placeholder="Senha" />
                                                <label v-if="validation.password != ''" id="password-error" class="error" for="password">{{ validation.password }}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group bmd-form-group"
                                                v-bind:class="{'is-filled': form.password_confirmation != '', 'has-danger' : validation.password_confirmation != '' }">
                                            
                                                <input refs="password_confirmation" :type="dataType.password_confirmation" class="form-control" v-model="form.password_confirmation" placeholder="Confirmação de Senha" />
                                                <label v-if="validation.password_confirmation != ''" id="password_confirmation-error" class="error" for="password_confirmation">{{ validation.password_confirmation }}</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group bmd-form-group">
                                                <md-tooltip md-direction="top">Mostrar Senhas</md-tooltip>
                                                Mostrar Senhas digitadas?
                                                <div class="togglebutton">
                                                    <label>
                                                        <input type="checkbox" v-model="is_active" value="1" @change="changeTypes" />
                                                        <span class="toggle"></span>
                                                        Sim
                                                    </label>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <label v-if="validation.password == ''" id="password-info" for="password" class="color-red">
                                            <b>Preencher para trocar a senha!</b> </label>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                :to-back="{name: 'dashboard'}"
                                text-save="Mudar Senha"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            is_active : false,
            dataType :{
                password : 'password',
                password_confirmation : 'password'
            },
            form : {
                password : '',
                password_confirmation : ''
            },
            validation: {
                name: '',
                username: '',
                profile_id: '',
                branch_id: '',
                email: '',
                password: '',
                password_confirmation: '',
            }
        }
    },
    computed : {
        auth(){
            return this.$store.state.auth.user
        }
    },
    methods : {
        changeTypes(){
            this.dataType.password = 'password'
            this.dataType.password_confirmation = 'password'
            if(this.is_active)
            {
                this.dataType.password = 'text'
                this.dataType.password_confirmation = 'text'
            }
        },
        onSubmit(){
            let valid = true, self=this;
            if(self.form.password != self.form.password_confirmation)
            {   
                self.validation.password = 'As senhas não conferem'
                self.validation.password_confirmation = 'As senhas não conferem'
                valid = false;
            }

            if(self.form.password == '')
            {
                self.validation.password = 'Informe a senha'
                valid = false;
            }

            if(self.form.password.length < 6)
            {
                self.validation.password = 'A senha possuir no mínimo 6(Seis) caracteres'
                valid = false
            }
            

            if(valid)
            {
               self.$root.$emit('onLoading');
               self.form.id         = self.auth.id
               self.form.name       = self.auth.name
               self.form.email      = self.auth.email
               self.form.username   = self.auth.username
               self.form.profile_id = self.auth.profile_id

                const response = self.$store.dispatch('users/edit', self.form);

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.$notify.success("Dados atualizados com sucesso!");
                    self.$router.push({'name': 'dashboard'});
                });

                response.catch(function (err) {
                    self.$root.$emit('onLoading');
                    if (err.status === 406) {
                        if (err.data.name !== undefined) {
                            self.validation.name = err.data.name[0];
                        }

                        if (err.data.email !== undefined) {
                            self.validation.email = err.data.email[0];
                        }

                        if (err.data.username !== undefined) {
                            self.validation.username = err.data.username[0];
                        }
                    }
                });
            }

        }
    },
}
</script>